module.exports = __webpack_public_path__ + "img/bg-img-1.807bd009.jpg";